// Import AOS - Animate on scroll plugin JS
import AOS from 'aos';

// Initialize AOS
document.addEventListener('DOMContentLoaded', () => {
	// Override some of the default settings
	const aosSettings = {
		disable: 'mobile',
		duration: 500,
		once: true
	};
	
	// Grab the prefers reduced media query.
	const mediaQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
	
	// Check if the media query matches or is not available (doesn't exist).
	if (mediaQuery.matches || !mediaQuery) {
		// User has no preference or the query isn't supported, so we init AOS.
		AOS.init(aosSettings);
	}
	
	// Adds an event listener to check for changes in the media query's value.
	mediaQuery.addEventListener('change', () => {
		if (mediaQuery.matches) {
			// User has no preference or the query isn't supported, so we init AOS.
			AOS.init(aosSettings);
		}
	});
});